import { useTranslation } from 'react-i18next';
import { APIProvider } from '@vis.gl/react-google-maps';

import MapView from '@/components/common/MapView';

const GOOGLE_API_KEY = 'AIzaSyAiua_n-0fnlbqEMOklF1Zf7RSaLbhWGhk';

export default function MapMain() {
  const { i18n } = useTranslation();
  const { language } = i18n;
  const region = language.split('-')[1];

  return (
    <APIProvider apiKey={GOOGLE_API_KEY} language={language} region={region}>
      <MapView />
    </APIProvider>
  );
}
